import { render } from "./loveFaceShadowBar.vue?vue&type=template&id=3e36b880&scoped=true&ts=true"
import script from "./loveFaceShadowBar.vue?vue&type=script&lang=ts"
export * from "./loveFaceShadowBar.vue?vue&type=script&lang=ts"

import "./loveFaceShadowBar.vue?vue&type=style&index=0&id=3e36b880&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e36b880"]])

export default __exports__